import React from 'react';
import FederalFilingSection from './FederalFilingSection';

const FedReturnsSubmitted = () => <FederalFilingSection />;
export default FedReturnsSubmitted;
